import React, { useState } from "react";

export default function FloatingField({
  id,
  label,
  placeholder,
  error,
  value,
  onChange,
  onBlur,
  type = "text",
  inputMode,
  autoComplete,
}) {
  const [focused, setFocused] = useState(false);
  const filled =
    value !== undefined &&
    value !== null &&
    String(value).trim().length > 0;
  const floated = focused || filled;

  return (
    <div className="fire-explosion__input-box-wrap">
      <div
        className={`fire-explosion__input-box${floated ? " fire-explosion__input-box--floated" : ""
          }${error ? " fire-explosion__input-box--error" : ""}`}
      >
        <label className="fire-explosion__input-box-label" htmlFor={id}>
          {label}
        </label>
        <input
          id={id}
          type={type}
          inputMode={inputMode}
          autoComplete={autoComplete}
          className="fire-explosion__input-box-field"
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            setFocused(false);
            if (onBlur) onBlur(e);
          }}
          placeholder={floated && placeholder ? placeholder : undefined}
        />
      </div>
      {error ? <div className="fire-explosion__error">{error}</div> : null}
    </div>
  );
}
